"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationInterceptor = void 0;
var AuthorizationInterceptor = /** @class */ (function () {
    function AuthorizationInterceptor(bearerToken) {
        this.bearerToken = bearerToken;
    }
    AuthorizationInterceptor.prototype.intercept = function (request, invoker) {
        var metadata = request.getMetadata();
        metadata['Authorization'] = "Bearer " + this.bearerToken;
        return invoker(request);
    };
    return AuthorizationInterceptor;
}());
exports.AuthorizationInterceptor = AuthorizationInterceptor;
exports.default = AuthorizationInterceptor;
